import { CircularProgress, type CircularProgressProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface SpinnerIconProps extends CircularProgressProps {
  /**
   * @prop {string} - id of the spinner icon component
   */
  id: string;

  /**
   * @prop {number | string} - size of the spinner icon
   * @default 50
   */
  size?: number | string;
}

const StyledCircularProgress = styled(CircularProgress)<
  CircularProgressProps & { size?: number | string }
>(({ size }) => {
  const sizeStyle = typeof size === 'number' ? `${size}px` : size ? `${size}` : '50px';
  return {
    width: sizeStyle,
    height: sizeStyle,
  };
});

export function SpinnerIcon({ id, ...props }: SpinnerIconProps) {
  return <StyledCircularProgress data-testid={`${id}-spinnerBox`} {...props} />;
}
